import { GITSTREAM_REST_API } from '../../../../common/consts/api';

function onGitHubClick() {
  window.location.replace(`${GITSTREAM_REST_API.LOGIN}/github_app?GDPR=true`);
}

export const loginProvidersToHandlers = {
  github: onGitHubClick
};
